export default "__VITE_ASSET__DxIkUnJM__"